import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
    FaTicketAlt,
    FaLaptop,
    FaUsers,
    FaCartPlus,
    FaChartLine,
    FaChevronDown,
    FaTools,
    FaArrowRight
} from 'react-icons/fa';
import styles from './Tecnico.module.css';

const Tecnico = () => {
    const [equiposOpen, setEquiposOpen] = useState(false);
    const [usuariosOpen, setUsuariosOpen] = useState(false);
    const [ticketsOpen, setTicketsOpen] = useState(true); // Default one open for better UX
    const [consumosOpen, setConsumosOpen] = useState(false);
    const [indicadoresOpen, setIndicadoresOpen] = useState(false);

    const toggleEquipos = () => {
        setEquiposOpen(!equiposOpen);
        setUsuariosOpen(false);
        setTicketsOpen(false);
        setConsumosOpen(false);
        setIndicadoresOpen(false);
    };

    const toggleUsuarios = () => {
        setUsuariosOpen(!usuariosOpen);
        setEquiposOpen(false);
        setTicketsOpen(false);
        setConsumosOpen(false);
        setIndicadoresOpen(false);
    };

    const toggleConsumo = () => {
        setConsumosOpen(!consumosOpen);
        setEquiposOpen(false);
        setUsuariosOpen(false);
        setTicketsOpen(false);
        setIndicadoresOpen(false);
    };

    const toggleTickets = () => {
        setTicketsOpen(!ticketsOpen);
        setEquiposOpen(false);
        setUsuariosOpen(false);
        setConsumosOpen(false);
        setIndicadoresOpen(false);
    };

    const toggleIndicadores = () => {
        setIndicadoresOpen(!indicadoresOpen);
        setEquiposOpen(false);
        setUsuariosOpen(false);
        setTicketsOpen(false);
        setConsumosOpen(false);
    };

    return (
        <div className={styles.container}>
            <header className={styles.header}>
                <h2 className={styles.title}>
                    <FaTools style={{ marginRight: '15px' }} />
                    Opciones Técnicas
                </h2>
                <p className={styles.subtitle}>Panel de administración y gestión para soporte técnico.</p>
            </header>

            <div className={styles.menuGrid}>
                {/* Gestión de Tickets */}
                <div className={`${styles.sectionCard} ${styles.tickets} ${ticketsOpen ? styles.isOpen : ''}`}>
                    <button className={styles.sectionHeader} onClick={toggleTickets}>
                        <div className={styles.headerLeft}>
                            <div className={styles.iconWrapper}>
                                <FaTicketAlt />
                            </div>
                            <span className={styles.sectionTitle}>Gestión de Tickets</span>
                        </div>
                        <FaChevronDown className={styles.chevron} />
                    </button>
                    <div className={styles.sectionContent}>
                        <div className={styles.linkList}>
                            <Link to="/asigtec" className={styles.menuLink}>
                                <FaArrowRight style={{ marginRight: '10px', fontSize: '0.8rem' }} />
                                Asignar técnico
                            </Link>
                            <Link to="/allhistorial" className={styles.menuLink}>
                                <FaArrowRight style={{ marginRight: '10px', fontSize: '0.8rem' }} />
                                Historial de servicios
                            </Link>
                        </div>
                    </div>
                </div>

                {/* Equipos */}
                <div className={`${styles.sectionCard} ${styles.equipos} ${equiposOpen ? styles.isOpen : ''}`}>
                    <button className={styles.sectionHeader} onClick={toggleEquipos}>
                        <div className={styles.headerLeft}>
                            <div className={styles.iconWrapper}>
                                <FaLaptop />
                            </div>
                            <span className={styles.sectionTitle}>Equipos</span>
                        </div>
                        <FaChevronDown className={styles.chevron} />
                    </button>
                    <div className={styles.sectionContent}>
                        <div className={styles.linkList}>
                            <Link to="/addequipo" className={styles.menuLink}>
                                <FaArrowRight style={{ marginRight: '10px', fontSize: '0.8rem' }} />
                                Crear Equipo
                            </Link>
                            <Link to="/asigequipo" className={styles.menuLink}>
                                <FaArrowRight style={{ marginRight: '10px', fontSize: '0.8rem' }} />
                                Asignar Equipo
                            </Link>
                            <Link to="/historasig" className={styles.menuLink}>
                                <FaArrowRight style={{ marginRight: '10px', fontSize: '0.8rem' }} />
                                Historial asignaciones
                            </Link>
                            <Link to="/dar-de-baja" className={styles.menuLink}>
                                <FaArrowRight style={{ marginRight: '10px', fontSize: '0.8rem' }} />
                                Dar De Baja
                            </Link>
                        </div>
                    </div>
                </div>

                {/* Usuarios */}
                <div className={`${styles.sectionCard} ${styles.usuarios} ${usuariosOpen ? styles.isOpen : ''}`}>
                    <button className={styles.sectionHeader} onClick={toggleUsuarios}>
                        <div className={styles.headerLeft}>
                            <div className={styles.iconWrapper}>
                                <FaUsers />
                            </div>
                            <span className={styles.sectionTitle}>Usuarios</span>
                        </div>
                        <FaChevronDown className={styles.chevron} />
                    </button>
                    <div className={styles.sectionContent}>
                        <div className={styles.linkList}>
                            <Link to="/adduser" className={styles.menuLink}>
                                <FaArrowRight style={{ marginRight: '10px', fontSize: '0.8rem' }} />
                                Crear Usuario
                            </Link>
                            <Link to="/cargos" className={styles.menuLink}>
                                <FaArrowRight style={{ marginRight: '10px', fontSize: '0.8rem' }} />
                                Cargos
                            </Link>
                            <Link to="/roles" className={styles.menuLink}>
                                <FaArrowRight style={{ marginRight: '10px', fontSize: '0.8rem' }} />
                                Roles
                            </Link>
                        </div>
                    </div>
                </div>

                {/* Consumos */}
                <div className={`${styles.sectionCard} ${styles.consumos} ${consumosOpen ? styles.isOpen : ''}`}>
                    <button className={styles.sectionHeader} onClick={toggleConsumo}>
                        <div className={styles.headerLeft}>
                            <div className={styles.iconWrapper}>
                                <FaCartPlus />
                            </div>
                            <span className={styles.sectionTitle}>Consumos</span>
                        </div>
                        <FaChevronDown className={styles.chevron} />
                    </button>
                    <div className={styles.sectionContent}>
                        <div className={styles.linkList}>
                            <Link to="/consumo" className={styles.menuLink}>
                                <FaArrowRight style={{ marginRight: '10px', fontSize: '0.8rem' }} />
                                Consumo de insumos
                            </Link>
                        </div>
                    </div>
                </div>

                {/* Indicadores */}
                <div className={`${styles.sectionCard} ${styles.indicadores} ${indicadoresOpen ? styles.isOpen : ''}`}>
                    <button className={styles.sectionHeader} onClick={toggleIndicadores}>
                        <div className={styles.headerLeft}>
                            <div className={styles.iconWrapper}>
                                <FaChartLine />
                            </div>
                            <span className={styles.sectionTitle}>Indicadores</span>
                        </div>
                        <FaChevronDown className={styles.chevron} />
                    </button>
                    <div className={styles.sectionContent}>
                        <div className={styles.linkList}>
                            <Link to="/indicagest" className={styles.menuLink}>
                                <FaArrowRight style={{ marginRight: '10px', fontSize: '0.8rem' }} />
                                Indicadores de gestión
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Tecnico;
